<template>
<v-card class='grey lighten-2 pl-1' id='invoiceable-top' >

    <appointment-action
      component-name="CreateInvoice"
      :initial-filters="filters"
      :initial-relationship="selectedRelationship"
      :touch="actionTouch"
      @success="touch++" >

      <template slot="ag-filters" >
        <invoiceable-client-list
          :touch="touch"
          @update:params="setFilters"
          @selected="setRelationship" />
      </template>
    </appointment-action>

  <!-- </v-card-text> -->

</v-card>
</template>

<script>
import HelpPopover from '@/components/ui/HelpPopover'
import StatusPicker from '@/components/pickers/StatusPicker'
import ConfirmInvoice from '@/components/invoice/manage/create/confirm.vue'
// import AppointmentList from '@/components/lists/AppointmentList.vue'
import InvoiceList from '@/components/invoice/InvoiceList.vue'
import InvoiceableClientList from './InvoiceableClientList.vue'
import AppointmentAction from '@/components/actions/AppointmentAction.vue'

export default {
  name: 'InvoiceableClients',
  components: {
    StatusPicker,
    HelpPopover,
    ConfirmInvoice,
    // AppointmentList,
    InvoiceList,
    AppointmentAction,
    InvoiceableClientList
  },
  props: {
    data: { type: Array, default: () => { return [] } },
    actions: { type: Array, default: () => { return [] } }
  },
  data () {
    return {
      confirmationTouch: 0,
      showInfo: false,
      page_size: 20,
      selectedLabels: ['N', 'C'],
      selectedRelationship: null,
      selectedAppointments: [],
      actionTouch: 0,
      touch: 0,
      requests: {
        invoices: {
          resource: 'invoiceguru.invoices',
          params: {
            ordering: '-id',
            page_size: 10
          }
        }
      },
      filters: {statuses: 'N,C'}
    }
  },
  mounted () {
    this.getInvoices()
  },
  watch: {
    activeDateRange () {
      this.selectedRelationship = null
    }
  },
  computed: {
    relationship () {
      if (this.selectedRelationship) {
        return this.getRelationById(this.selectedRelationship.relationship_id)
      }
      return null
    },
    // params () {
    //   return {
    //     after_utc: this.dateRange.fromDateIso,
    //     before_utc: this.dateRange.toDateIso,
    //     relationships: this.selectedRelationship.relationship_id,
    //     page_size: this.page_size,
    //     ordering: 'start_time',
    //     statuses: this.selectedLabels.join(',')
    //   }
    // },
    recentInvoices () {
      return this.getObjectPath(this.requests.invoices, 'result.results', [])
    },
    invoicesInProgress () {
      let customersInProgress = {}
      this.data.forEach((inv) => {
        if (inv.status.toLowerCase() === 'new') {
          customersInProgress[inv.customer_id] = inv
        }
      })
      return customersInProgress
    },
    dateRange () {
      return {
        fromDateIso: this.activeDateRange.from,
        fromDate: this.dateformat(this.activeDateRange.from),
        toDateIso: this.activeDateRange.to,
        toDate: this.dateformat(this.activeDateRange.to)
      }
    },
    activeDateRange () {
      return this.$store.getters.activeDateRange
    },
    events () {
      let vm = this
      let events = {
        'primarycta': (invoice) => { vm.$emit('primarycta', invoice) }
      }
      this.actions.forEach((action) => {
        events[action.action] = (invoice) => {
          vm.$emit(action.action, invoice)
        }
      })
      return events
    }
  },
  methods: {
    invoiceCreated (invoice) { },
    hasInvoicesInProgress (clientId) {
      if (this.invoicesInProgress && this.invoicesInProgress[clientId]) {
        return true
      }
      return false
    },
    setRelationship (rel) {
      rel.id = rel.relationship_id
      this.selectedRelationship = rel
    },
    setFilters (params) {
      if (params.statuses && Array.isArray(params.statuses)) {
        params.statuses = params.statuses.join(',')
      }
      if (params.after) { params.after_utc = params.after }
      if (params.before) { params.before_utc = params.before }

      this.filters = params
    },
    setSelectedRelationship (rel) {
      if (this.$vuetify.breakpoint.xsOnly) {
        let options = {
          relationshipId: rel.relationship_id,
          touchClear: Math.random(),
          initialDateRange: this.activeDateRange
        }
        this.launchInvoiceDialog(options)
      } else {
        this.selectedRelationship = rel
        this.confirmationTouch++
      }
    },
    selectNext () {
      if (this.invoiceableClients && this.invoiceableClients.length > 0) {
        this.setSelectedRelationship(this.invoiceableClients[0])
      }
    },
    getInvoices () {
      this.$request('get', this.requests.invoices)
    },
    getClasses (rel) {
      let prog = `in-progress-${this.hasInvoicesInProgress(rel.client_id)}`
      let isSelected = false
      if (this.selectedRelationship && this.selectedRelationship.relationship_id === rel.relationship_id) {
        isSelected = true
      }
      let selected = `selected-${isSelected}`
      return [prog, selected]
    }
  },
  i18n: {
    messages: {
      en: {
        btn: {
          createInvoice: 'Invoice'
        },
        title: {
          summary: '{fromDate} - {toDate}'
        },
        page: {
          title: 'Invoiceable clients',
          subheading: 'Here is a list of clients who you\'ve seen between {fromDate} and {toDate}',
          noresults: '🎉 You\'ve invoiced all your clients!',
          info: 'This view shows you clients who have appointments that may need invoicing',
          resultsshowing: 'Currently showing clients with appointments between {fromDate} and {toDate}',
          withstatuses: 'With the following statuses'
        },
        list: {
          appointments: 'appointment | appointments'
        }
      }
    }
  }
}
/*
for appointment:
  if status in invoiceable
*/
</script>

<style scoped>
.in-progress-true {
  background-color: #455A64;
}
.selected-true {
  background-color: #263238;
}
</style>



// WEBPACK FOOTER //
// Index.vue?ab7bcb02